var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.955 160.933C163.955 162.596 162.595 163.956 160.933 163.956H141.667V170H160.933C165.92 170 170 165.92 170 160.933V141.667H163.955V160.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.933 6.04444C162.595 6.04444 163.955 7.40444 163.955 9.06667V28.3333H170V9.06667C170 4.08 165.92 0 160.933 0H141.667V6.04444H160.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06667 163.956C7.40444 163.956 6.04444 162.596 6.04444 160.933V141.667H0V160.933C0 165.92 4.08 170 9.06667 170H28.3333V163.956H9.06667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04444 9.06667C6.04444 7.40444 7.40444 6.04444 9.06667 6.04444H28.3333V0H9.06667C4.08 0 0 4.08 0 9.06667V28.3333H6.04444V9.06667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3734 71.8534C73.5156 71.8534 67.1689 78.2 67.1689 86.0578C67.1689 93.9156 73.5156 100.262 81.3734 100.262C89.2312 100.262 95.5778 93.9156 95.5778 86.0578C95.5778 78.2 89.2312 71.8534 81.3734 71.8534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.022 58.2533H99.0533L96.1822 51.3022C95.2 49.0356 92.48 46.92 89.9867 46.92H72.3822C69.9644 46.92 67.1689 49.0356 66.2622 51.3022L63.3911 58.2533H40.2711C37.8533 58.2533 34 59.84 34 62.2578V112.276C34 114.693 37.8533 117.036 40.2711 117.036H122.022C124.44 117.036 128.444 114.693 128.444 112.276V62.2578C128.444 59.84 124.516 58.2533 122.022 58.2533ZM81.3733 108.196C69.1333 108.196 59.3111 98.2978 59.3111 86.0578C59.3111 73.8933 69.2089 63.9956 81.3733 63.9956C93.5378 63.9956 103.436 73.8933 103.436 86.0578C103.436 98.2978 93.5378 108.196 81.3733 108.196ZM115.524 75.7822C112.276 75.7822 109.707 73.1378 109.707 69.9645C109.707 66.7156 112.351 64.1467 115.524 64.1467C118.698 64.1467 121.342 66.7911 121.342 69.9645C121.418 73.2133 118.773 75.7822 115.524 75.7822Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 170,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.72ddc3f916633bc63a7a4580f564ed35.svg";
export { ForwardRef as ReactComponent };